import {Operation} from "./Operation.js";


export class Min extends Operation {

    static displayName() {
        return "Min";
    }

    static isNumeric() {
        return true;
    }

    static isCategorical() {
        return false;
    }

    static handlesDate() {
        return true;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = newValue || 0;
        }
        this.currValue = Math.min(this.currValue, newValue);
    }

}

export default Min;